<template>
  <AsidePanel
    ref="asidePanel"
    :components="components"
    :isExpanded="isExpanded"
    :itemType="itemAsideType"
    :showSaveButton="false"
    :viewport="viewport"
  >
    <template v-slot:instructions>
      <ApplicationInstructions />
      <IdmOauthImportBanner />
    </template>
    <template v-slot:avatar>
      <AsideIcon
        icon="sso"
      />
    </template>
    <template v-slot:footerCustomContent>
      <ApplicationChooserQuickAccess
        @templateSelect="footerTemplateSelect"
      />
    </template>
  </AsidePanel>
</template>

<script>
import { ItemTypeConsts, ItemTypeRoutes } from 'client/util/Constants';
import ApplicationChooserQuickAccess from 'client/applications/ApplicationChooserQuickAccess.vue';
import ApplicationInstructions from 'client/applications/ApplicationInstructions.vue';
import ApplicationTemplateItemTable from 'client/components/ItemTable/ApplicationTemplateItemTable.vue';
import AsideIcon from 'client/components/AsidePanel/AsideIcon.vue';
import AsidePanel from 'client/components/AsidePanel/AsidePanel.vue';
import AsidePanelPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelPropsMixin';
import IdmOauthImportBanner from 'client/applications/import/IdmOauthImportBanner.vue';
import PageNavigationUtil from 'client/util/PageNavigationUtil';

export default {
  name: 'ApplicationChooserAsidePanel',

  components: {
    AsidePanel,
    AsideIcon,
    ApplicationChooserQuickAccess,
    ApplicationInstructions,
    IdmOauthImportBanner,
  },

  mixins: [
    AsidePanelPropsMixin,
  ],

  props: {
    itemType: {
      type: String,
      default: ItemTypeConsts.sso,
    },
  },

  data() {
    const { applicationTemplate, sso, ssoTemplate } = ItemTypeConsts;
    const itemAsideType = this.itemType === sso ? ssoTemplate : applicationTemplate;

    return {
      components: [{
        backboneView: null,
        itemType: itemAsideType,
        label: ' ',
        vueComponent: ApplicationTemplateItemTable,
        vueComponentProps: {
          boundItemsUrl: undefined,
          inDetailsAsidePanel: false,
        },
      }],
      itemAsideType,
      route: ItemTypeRoutes[this.itemType],
    };
  },

  methods: {
    footerTemplateSelect(templateId) {
      PageNavigationUtil.setLocation(`${this.route}/configure/${templateId}`);
    },
  },
};
</script>
